import { EpimsBaseEntityDto } from './epim-base.dto';

export class CorrespondenceTrackerHistoryDto extends EpimsBaseEntityDto {
  ActionTaken: string;
  ActionDate: Date;
  RegisterId: string;
  ActionRemarks: string;
  ActionReviewer: string;
}
